const $ = window.jQuery;
import { observeElementInView } from "../vendor/inview-observer";
// eslint-disable-next-line import/no-unresolved -- swiper/bundle is a valid package export; resolver doesn't follow package.json "exports"
import Swiper from "swiper/bundle";

const MOBILE_BREAKPOINT = 1024;

$(function () {
	"use strict";

	const sections = document.querySelectorAll(".services .services-list");

	sections.forEach((list) => {
		const swiperEl = list.querySelector(".services-swiper");
		if (!swiperEl) return;

		let swiperInstance = null;
		let resizeListenerAttached = false;

		const getSlidesOffsetAfter = () => {
			const slide = swiperEl.querySelector(".swiper-slide");
			if (!slide) return 0;

			return Math.max(0, swiperEl.clientWidth - slide.offsetWidth);
		};

		const initSwiper = () => {
			if (window.innerWidth >= MOBILE_BREAKPOINT) {
				if (swiperInstance) {
					swiperInstance.destroy(true, true);
					swiperInstance = null;
				}
				return;
			}

			if (swiperInstance) return;

			swiperInstance = new Swiper(swiperEl, {
				slidesPerView: "auto",
				spaceBetween: 20,
				slidesOffsetAfter: getSlidesOffsetAfter(),
				speed: 700,
				navigation: {
					nextEl: list.querySelector(".swiper-button-next"),
					prevEl: list.querySelector(".swiper-button-prev"),
				},
				on: {
					resize(swiper) {
						swiper.params.slidesOffsetAfter = getSlidesOffsetAfter();
					},
				},
			});
		};

		const callback = () => {
			initSwiper();

			if (!resizeListenerAttached) {
				window.addEventListener("resize", initSwiper);
				resizeListenerAttached = true;
			}
		};

		observeElementInView(list.closest(".services"), callback);
	});
});
